import type { ImageCardProps } from '3-components/ImageCard/ImageCard';
import type { RealEstateListingQuery } from 'cms/cms';
import type { ContentModelReference } from 'cms/cms-types';
import HTMLReactParser from 'html-react-parser';
import { resolveCategoriesToBadges } from './badgeResolver';
import { resolveImageReferenceToImage } from './imageResolver';


export type RealEstatePage = NonNullable<RealEstateListingQuery['RealestatePage']>;
export type RealEstatePageItems = NonNullable<RealEstatePage['items']>;

export const resolveRealEstatePagesToImageCards = (items: RealEstatePageItems): ImageCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { AssetName, Excerpt, PreviewImage, AssetAddress, ContentLink, SectorCategories } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(SectorCategories);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=768', imgSrcSets);

        return {
            ...(ContentLink?.Url && { href: ContentLink.Url }),
            title: AssetName ?? '',
            subtitle: AssetAddress ?? '',
            ...(Excerpt && { children: HTMLReactParser(Excerpt as string) }),
            tags,
            ...(img && { img }),
            ctaText: 'Learn more',
            asLink: true,
        };
    });
};
